module.exports = __webpack_public_path__ + "static/media/open_game.22452e75.mp3";